<template>
  <div class="box" style="height:100%;">
    <div class="notice">
      <h1 class="title">
        <div style="text-align:center;font-weight: 600;color: rgba(255, 255, 255, 0.8);">
          <span> {{ APP_WINNY_NAME }}行情简报</span>
        </div>
      </h1>
      <div v-if="selectGood" class="contentMsg">
        <div class="twoTitle">
          {{ selectGood.symbol }}现货行情简报
        </div>
        <div class="content">
          {{ selectGood.symbol }}现货合同开盘价{{ Number(selectGood.open)==0?'--':Number(selectGood.open).toFixed(selectGood.coinDigitalNum) }}，最高价{{ Number(selectGood.high)==0?'--':Number(selectGood.high).toFixed(selectGood.coinDigitalNum) }}，
          最低价{{ Number(selectGood.low)==0?'--':Number(selectGood.low).toFixed(selectGood.coinDigitalNum) }}，均价{{ Number(selectGood.averagePrice)==0?'--':Number(selectGood.averagePrice).toFixed(selectGood.coinDigitalNum) }}，收盘价{{ Number(selectGood.yescloseprice)==0?'--':Number(selectGood.yescloseprice).toFixed(selectGood.coinDigitalNum) }}，
          较上一交易日{{ Number(selectGood.quote) < 0 ? '跌':'涨' }}{{ Number(selectGood.quote).toFixed(selectGood.coinDigitalNum) | subSign }}元，涨幅{{ selectGood.quotechange | addSign }}；订货量{{ selectGood.warehouseBad&&Number(selectGood.warehouseBad) < 0 ?'减少':'增加' }}{{ selectGood.warehouseBad&&Number(selectGood.warehouseBad)==0?'--':Number(selectGood.warehouseBad).toFixed(selectGood.quantityNum) | subSign }}{{ selectCommodityStrategy.unitQuantifier }}。（报价单位：元/{{ selectCommodityStrategy.unitQuantifier }}）
        </div>
        <div class="time">
          {{ selectGood.tradeDay | dateFormateDay }}
        </div>
      </div>
      <div v-else class="no-datas1">
        <div class="no-data-img" style="margin: 150px auto 0px; width: 100px; height: 100px;">
          <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
        </div><div class="no-data" style="margin-top: 10px !important; text-align: center;">暂无数据</div>
      </div>

    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
export default {
  name: 'NoticeJB',
  filters: {
    subSign(str) { // 删除"-"
      str = str + ''
      return str.split('-').join('')
    }
  },
  data() {
    return {

      currentTime: new Date().getTime(),
      APP_WINNY_NAME: window.g.APP_WINNY_NAME
    }
  },
  computed: {
    // 商品策略
    ...mapGetters(['commodityStrategyGetter', 'BusinessDetailGetter']),
    item() {
      const item = this.$store.state.hqData.item.symbolId
      if (item) {
        return this.$store.state.hqData.item.symbolId
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbolId
        } else {
          return '--'
        }
      }
    },
    marketDetails() {
      const marketDetails = this.$store.state.hqData.marketDetails
      if (marketDetails.length > 0) {
        return marketDetails
      } else {
        return [
          {
            close: '0.00',
            quotechangeColor: 'white',
            quotechange: '0.00%',
            high: '0',
            low: '0',
            amount: '0'
          }
        ]
      }
    },
    selectCommodityStrategy() {
      if (this.item !== '--' && this.commodityStrategyGetter.length > 0) {
        for (const CommodityStrategy of this.commodityStrategyGetter) {
          if (this.item == CommodityStrategy.commodityId) {
            return CommodityStrategy
          }
        }
      } else if (this.item == '--' && this.commodityStrategyGetter.length > 0) {
        return this.commodityStrategyGetter[0]
      }
      return {
        canBuy: '--',
        canDqDelivery: '--',
        canSell: '--',
        canShow: '--',
        canTqDelivery: '--',
        canTqTransfer: '--',
        canTransfer: '--',
        commodityCode: '--',
        commodityId: null,
        commodityName: '--',
        feeStrategyId: '--',
        guidePrice: '--',
        holdStrategyId: '--',
        margin: '--',
        marginStrategyId: '--',
        marginType: '--',
        marketPrice: '--',
        maxHoldAmount: '--',
        maxSingleTradeAmount: '--',
        maxUpDownWidth: '--',
        minAmountChange: '--',
        minPickupAmount: '--',
        minPriceChange: '--',
        minSingleTradeAmount: '--',
        offerEndTime: 0,
        openFee: '--',
        openFeeType: '--',
        pickupCountdown: '--',
        pickupStandard: '--',
        pickupStartTime: 0,
        tradeStrategyId: '--',
        transferFee: '--',
        transferFeeType: '--',
        unitNumeral: '--',
        unitQuantifier: '--',
        sellMargin: '--',
        sellMarginType: '--'
      }
    },

    selectGood() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        for (let index = 0; index < this.BusinessDetailGetter.length; index++) {
          const element = this.BusinessDetailGetter[index]
          if (this.$store.state.hqData.item.symbolId == element.symbolId) {
            element.numStr = this.$store.state.hqData.item.numStr
            element.coinDigitalNum = this.$store.state.hqData.item.coinDigitalNum
            element.quantityNum = this.$store.state.hqData.item.quantityNum
            return element
          }
        }
      } else {
        if (this.BusinessDetailGetter.length > 0) {
          for (let index = 0; index < this.BusinessDetailGetter.length; index++) {
            const element = this.BusinessDetailGetter[index]
            if (this.marketDetails[0].symbolId == element.symbolId) {
              element.numStr = this.marketDetails[0].numStr
              element.coinDigitalNum = this.marketDetails[0].coinDigitalNum
              element.quantityNum = this.marketDetails[0].quantityNum
              return element
            }
          }
        } else {
          return {
            averagePrice: 0,
            commodityCode: '',
            high: 0,
            low: 0,
            open: 0,
            quote: 0,
            quotechange: '',
            symbol: '',
            symbolId: '',
            warehouseBad: -20,
            yescloseprice: 0,
            tradeDay: '',
            numStr: /^(\d+)\.(\d{0,2}).*$/,
            coinDigitalNum: 2,
            quantityNum: 2
          }
        }
      }
      return ''
    }
  },
  watch: {},
  methods: {

  }
}
</script>
<style scoped lang="scss">
.box {
  width: 100%;
  background-color: #141517;
  overflow: hidden;
  .notice {
    height: 100%;
    .title {
      padding-top: 29px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      font-size: 16px;
      color: #DFDFDF;
    }

  }

}
.contentMsg{
  padding:27px 32px 27px 28px;
  .twoTitle{
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 14px;
    color: #989898;
    line-height: 22px;
  }
  .content{
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 14px;
    color: #989898;
    line-height: 22px;
  }
  .time{
    margin:20px 0;
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 14px;
    color: #989898;
    text-align: right;
  }
}
</style>
